import React from 'react'

import {
    Tabs,
    Card
} from 'antd'

import AdminUsers from './users'
import AdminPermissions from './permissions'

const { TabPane } = Tabs

class AdminManager extends React.Component {
    
    state = {
        activeTab: 'users'
    }
    
    render(){

        const { activeTab } = this.state

        return(
            <Card>
                <Tabs
                    onChange={(activeTab) => this.setState({ activeTab })}
                >
                    <TabPane
                        key="users"
                        tab="Users"
                    >
                        {activeTab == "users" && <AdminUsers/>}
                    </TabPane>
                    <TabPane
                        key="permissions"
                        tab="Permissions"
                    >
                        <AdminPermissions/>
                    </TabPane>
                </Tabs>
            </Card>
        )
    }
}

export default AdminManager


// WEBPACK FOOTER //
// ./src/components/admin/index.js